import { render, staticRenderFns } from "./hazardCausePrevention.vue?vue&type=template&id=0a48c6f2"
import script from "./hazardCausePrevention.vue?vue&type=script&lang=js"
export * from "./hazardCausePrevention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a48c6f2')) {
      api.createRecord('0a48c6f2', component.options)
    } else {
      api.reload('0a48c6f2', component.options)
    }
    module.hot.accept("./hazardCausePrevention.vue?vue&type=template&id=0a48c6f2", function () {
      api.rerender('0a48c6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/hazardEquipment/hazardCausePrevention.vue"
export default component.exports